export const FINYEAR_CUSTOMER_REQUEST  = 'FINYEAR_CUSTOMER_REQUEST';
export const FINYEAR_CUSTOMER_REQUEST_FAILURE  = 'FINYEAR_CUSTOMER_REQUEST_FAILURE';
export const GET_FINYEAR_CUSTOMERS  = 'GET_FINYEAR_CUSTOMERS';